import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import CrudApiClient from './crudapiclient';

class SkuAlbumAPIClient extends CrudApiClient {
  constructor(target?: string) {
    let url = GATEWAY_API_URL + '/skualbum';
    if (target && target !== '') url += '/' + target;
    super(url);
  }

  async search(query: any, page: number, size: number, meta: MetaQuery | undefined): Promise<any> {
    try {
      if (!query.filters || query.filters.length == 0) {
        return [];
      }
      return await super.search(query, page, size, meta);
    } catch (error) {
      console.error(`Error searching entities with Query:`, query, error);
      throw error;
    }
  }
}

export { SkuAlbumAPIClient };
